import { render, staticRenderFns } from "./SolidLogin.vue?vue&type=template&id=1478bcda&scoped=true&shadow"
import script from "./SolidLogin.vue?vue&type=script&lang=js&shadow"
export * from "./SolidLogin.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SolidLogin.vue?vue&type=style&index=0&id=1478bcda&scoped=true&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1478bcda",
  null
  ,true
)

export default component.exports